import './styles.scoped.css'
import {useState, useEffect} from 'react'
import {Typography, Button, Avatar, IconButton} from '@mui/material'
import {Edit, Menu} from '@mui/icons-material'
import {useAuth} from '../../contexts/AuthContext'
import {getInitials, getColorFromName} from '../../utils/helpers'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {useNavigate} from 'react-router-dom'
import {useMobile} from '../../hooks'
import {ChangePassword} from './components'

export default () => {
    const [open, setOpen] = useState(false)
    const [initials, setInitials] = useState(null)
    const [avatarColor, setAvatarColor] = useState(null)
    const {user, roles, permissions} = useAuth()
    const {mobile} = useMobile()
    const {setMobileSidebar} = useGlobalStates()
    const navigate = useNavigate()

    useEffect(() => {
        if (mobile) {
            setMobileSidebar(false)
        }
    }, [])

    useEffect(() => {
        if (!user?.avatar_url) {
            setInitials(getInitials(user?.first_name + ' ' + user?.last_name))
            setAvatarColor(getColorFromName(user?.first_name + ' ' + user?.last_name))
        }
    }, [user])

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <div className="title">
                            <IconButton onClick={() => setMobileSidebar(true)}>
                                <Menu />
                            </IconButton>
                            <Typography variant="h6" color="text.primary">
                                Account Settings
                            </Typography>
                        </div>
                        {permissions?.includes('admin.settings.write') && (
                            <IconButton onClick={() => navigate('/account-settings/edit-profile')}>
                                <Edit />
                            </IconButton>
                        )}
                    </div>
                    <br />
                </>
            ) : (
                <>
                    <div className="header">
                        <div className="title">
                            <Typography variant="h5" color="text.primary">
                                Profile
                            </Typography>
                            <Typography variant="body1" color="text.primary">
                                Manage your account details, update your preferences, and keep your information up to date.
                            </Typography>
                        </div>
                        {permissions?.includes('admin.settings.write') && (
                            <Button
                                variant="outlined"
                                startIcon={<Edit />}
                                onClick={() => navigate('/account-settings/edit-profile')}
                                style={{minWidth: 140}}>
                                Edit Profile
                            </Button>
                        )}
                    </div>
                </>
            )}
            <br />
            <br />
            <div className="profile">
                {user?.avatar_url ? (
                    <Avatar src={user?.avatar_url} style={mobile ? {width: 64, height: 64} : {width: 128, height: 128}} />
                ) : (
                    <Avatar
                        style={
                            mobile
                                ? {backgroundColor: avatarColor, width: 64, height: 64, fontSize: 33}
                                : {backgroundColor: avatarColor, width: 128, height: 128, fontSize: 66}
                        }>
                        {initials}
                    </Avatar>
                )}
                <div style={{textAlign: mobile ? 'center' : 'left'}}>
                    <Typography variant="h6" color="text.primary">
                        {user?.first_name + ' ' + user?.last_name}
                    </Typography>
                    <br />
                    <Typography variant="subtite1" color="text.primary">
                        {user?.email}
                    </Typography>
                </div>
            </div>
            <br />
            <br />
            <div className="form">
                <Typography variant="h8" color="text.primary" style={{width: mobile ? 115 : 180}}>
                    Phone Number{mobile ? ':' : ''}
                </Typography>
                <Typography variant="subtite1" color="text.primary">
                    {user?.phone}
                </Typography>
            </div>
            <br />
            <div className="form">
                <Typography variant="h8" color="text.primary" style={{width: mobile ? 115 : 180}}>
                    Role{mobile ? ':' : ''}
                </Typography>
                <Typography variant="subtite1" color="text.primary">
                    {roles}
                </Typography>
            </div>
            <br />
            <div className="form">
                <Typography variant="h8" color="text.primary" style={{width: mobile ? 115 : 180}}>
                    Password{mobile ? ':' : ''}
                </Typography>
                <Button variant="outlined" onClick={() => setOpen(true)}>
                    Change Password
                </Button>
            </div>
            <br />
            <br />
            <br />
            <br />
            <ChangePassword open={open} setOpen={setOpen} />
        </>
    )
}
